import { FC, ReactNode, useState } from "react";

/*
    A section whose title opens and closes it. The Danger Zone's disclosure, in the page's
    neutral colours. Collapsed until asked for unless told otherwise. `tags` sit in the title
    bar either way; `summary` is the one line that stands in for the body while it is closed,
    so a folded section still says what is in it (MPN-2077).
*/
const Disclosure: FC<{
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  summary?: ReactNode;
  tags?: ReactNode;
  className?: string;
}> = ({ title, children, defaultOpen = false, summary, tags, className }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`population-disclosure${className ? ` ${className}` : ""}`}>
      <button
        type="button"
        className="population-disclosure__toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="population-disclosure__chevron" aria-hidden="true">{open ? "▾" : "▸"}</span>
        {title}
        {tags}
      </button>
      {!open && summary != null && (
        <div className="population-disclosure__summary">{summary}</div>
      )}
      {open && <div className="population-disclosure__body">{children}</div>}
    </div>
  );
};

export default Disclosure;
